import React from 'react'
import { withNavigation } from '../templates/navigation/withNavigation'
import ImageList from '../templates/image-list/ImageList'

const ImagePage = () => <ImageList />

export default withNavigation({ title: 'Gallery Image' })(ImagePage)



// WEBPACK FOOTER //
// ./src/components/pages/ImagePage.js